import { MethodsData, MethodValue } from "../components/ManageMethods/types";

export function selectorMethodExistsInData({
  data,
  value
}: {
  data: MethodsData;
  value: MethodValue | null | undefined;
}): boolean {
  if (!value) {
    return false;
  }

  switch (value.type) {
    case "Account":
      return !!data.accounts?.some(account => account.id === value.id);

    case "InternalAccount":
      return !!data.internalAccounts?.some(
        internalAccount => internalAccount.id === value.id
      );

    case "CreditCard":
      return !!data.creditCards?.some(
        creditCard => creditCard.paymentMethodId === value.id
      );

    case "PaymentCard":
      return !!data.paymentCards?.some(
        paymentCard => paymentCard.paymentCardId === value.id
      );

    default:
      return false;
  }
}
